(function(window, document) {
    'use strict';

    document.querySelectorAll('.form-group--checkbox').forEach(function(element) {
        var container = element;
        var checkbox = container.querySelector('input[type="checkbox"]');

        checkbox.addEventListener('focusin', function () {
            container.classList.add('checkbox--focus');
        });

        checkbox.addEventListener('focusout', function () {
            container.classList.remove('checkbox--focus');
        });
    });

})(window, document);
